/**
 * What the toolbar of the selected drawing (TV-19) shows and does: props of
 * DrawingToolbar. Changes go to the engine through useDrawings, the place of the
 * toolbar stays in the chart settings, so it survives closing it and F5 (D17).
 *
 * @param {object} drawingsApi - useDrawings
 * @param {{ settings: object, updateSettings: Function }} chartSettingsApi - useChartSettings
 * @param {(id: string) => void} openSettings - useDrawingSettingsModal
 * @returns {{
 *   drawing: object|null, palette: string[], savedPosition: { x: number, y: number }|null,
 *   onSavePosition: Function, onChangeStyle: Function, onClone: Function, onToggleLock: Function, onRemove: Function,
 *   onOpenSettings: Function,
 * }} drawing: the engine.getDrawings() item that is selected, null without a selection
 */
const useDrawingToolbar = (drawingsApi, { settings, updateSettings }, openSettings) => {
  const { drawings, selectedId, palette, setStyle, setLocked, clone, remove } = drawingsApi;
  const drawing = drawings.find(({ id }) => id === selectedId) || null;

  return {
    drawing,
    palette,
    savedPosition: settings.drawingToolbarPosition,
    onSavePosition: (position) => updateSettings({ drawingToolbarPosition: position }),
    onChangeStyle: (change) => setStyle(selectedId, change),
    onClone: () => clone(selectedId),
    onToggleLock: () => setLocked(selectedId, !drawing.isLocked),
    onRemove: () => remove(selectedId),
    onOpenSettings: () => openSettings(selectedId),
  };
};

export default useDrawingToolbar;
